import React from "react";
import { createRoot } from 'react-dom/client';
import { ProductCard } from '../react_components/ProductCard';

const rootElements = Array.from(document.querySelectorAll('[data-headless-product-card-target]'));

// creates the roots to render the react components
if (rootElements.length > 0) {
  rootElements.forEach(rootEl => {
    const root = createRoot(rootEl);
    const productID = rootEl.getAttribute('data-headless-product-card-target');
    const productData = JSON.parse(document.querySelector(`[data-headless-product-card-data="${productID}"]`).innerHTML);

    if (root) {
      root.render(
        <ProductCard product={productData} />
      );
      rootEl._reactRootContainer = root;
    }
    window.resizeTo(window.innerWidth, window.innerHeight);
  });
}
